import React, { useState, useEffect } from 'react'
import { Modal, Form, Radio, Input, Spin, App, Space } from 'antd';
import Icon from '../../cpn/Icon';
import { useFYbohuiMutation, useFYupdatecontentMutation } from '../../store/DianShangYeWuApi';

function ExpenseNodeCheckEdit(props) {
    const {message} = App.useApp();
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [updateIsFetching, setUpdateIsFetching] = useState(false);
    const [bohui] = useFYbohuiMutation();
    const [updateContent] = useFYupdatecontentMutation();
    useEffect(() => {              
        form.setFieldsValue({
            fy_sp_state: props.fy_sp_state ==='4'?'4':'3',
            fy_sp_content: props.fy_sp_content,
        });
    }, [
        props.fy_sp_id, 
        props.fy_sp_jd_xuhao, 
        props.fy_sp_jd_name, 
        props.fy_sp_yh_id, 
        props.fy_sp_yh_name, 
        props.fy_sp_uid, 
        props.fy_sp_uname, 
        props.fy_sp_state, 
        props.fy_sp_content, 
        props.sortedData,
        props.fy_sp_state_time,
        form
    ]);
    return (
        <>
            <Space orientation='vertical' size={1}>
                <span style={{color:props.fy_sp_state==='4' ? 'red' : 'green',fontWeight:"bold"}}>
                    {props.fy_sp_state==='4' ? '已驳回' : '已同意'}
                    {props.fy_sp_content? '：'+props.fy_sp_content :''}
                </span>
                <span>{props.yh_name} {props.fy_sp_state_time} </span>
                <Icon type="edit"  onClick={() => {setOpen(true);}} title='修改审批说明'/>
            </Space>
            <Modal 
                open={open} 
                onCancel={() => {
                    setOpen(false);
                    setUpdateIsFetching(false);
                }} 
                footer={null}
                title='审批费用单'
            >
                <Spin spinning={updateIsFetching} tip="审批中...">
                    <Form
                        form={form}
                        name={`form_expense_${props.fy_sp_id}`}
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 5}}
                        wrapperCol={{ span: 19 }}
                        onFinish={(value) => {
                            if((value.fy_sp_state === '3' && props.fy_sp_state === '3') || (value.fy_sp_state === '4' && props.fy_sp_state === '4') || (value.fy_sp_state === '3' && props.fy_sp_state==='5')){
                                updateContent({
                                    'fy_sp_id': props.fy_sp_id,
                                    'fy_sp_content': value.fy_sp_content,
                                    'fy_sp_yh_id': props.fy_sp_yh_id,
                                    'fy_sp_yh_name': props.fy_sp_yh_name
                                }).then((res) => {
                                    if(res.data.Status === 'success'){
                                        message.success('审批说明修改成功');
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }else{
                                        message.error('审批说明修改失败'+res.data.Message);
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }
                                });
                                return;                            
                            }else if(value.fy_sp_state === '4' &&  props.fy_sp_state === '3'){
                                bohui({
                                    'fy_sp_id': props.fy_sp_id,
                                    'fy_id': props.fy_id,
                                    'fy_sp_yh_id': props.fy_sp_yh_id,
                                    'fy_sp_content': value.fy_sp_content
                                }).then((res) => {
                                    if(res.data.Status === 'success'){
                                        message.success('驳回成功');
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }else{
                                        message.error('驳回失败'+res.data.Message);
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }
                                });
                            }else{
                                console.log(props.fy_sp_state, value.fy_sp_state);
                                
                                if(props.fy_sp_state === '5' && value.fy_sp_state === '4'){
                                    message.error('已结束的单据不能驳回！')
                                }else if(props.fy_sp_state === '4' && value.fy_sp_state === '3'){
                                    message.error('已驳回的单据不能同意审批！')
                                }
                                setUpdateIsFetching(false);
                            }
                         
                        }}
                    >                    
                    <Form.Item name="fy_sp_state" label="审批意见">
                        <Radio.Group disabled>
                            <Radio value="3">同意</Radio>
                            <Radio value="4">驳回</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item name="fy_sp_content" label="说明">
                        <Input.TextArea rows={4} />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 5, span: 19 }}>
                        <Icon type="save"  onClick={() => {
                            // 弹出加载中Spin
                            setUpdateIsFetching(true);
                            form.submit();
                        }}/>
                    </Form.Item>
                </Form>
                </Spin>
            </Modal>
        </>
    )
}

export default ExpenseNodeCheckEdit